(() => {
  class OndelieMediaStory extends HTMLElement {
    connectedCallback() {
      if (this.dataset.omsReady === 'true') return;
      this.dataset.omsReady = 'true';

      this.video = this.querySelector('[data-oms-video]');
      this.toggle = this.querySelector('[data-oms-video-toggle]');
      this.label = this.querySelector('[data-oms-video-label]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.toggle?.addEventListener('click', () => this.togglePlayback());
      this.classList.add('is-mounted');

      if (this.reduceMotion) {
        this.video?.pause();
        this.renderPlaybackState(false);
        this.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting) return;
          this.classList.add('is-visible');
          this.video?.play().catch(() => this.renderPlaybackState(false));
          this.observer?.disconnect();
        },
        {threshold: 0.14}
      );

      this.observer.observe(this);
    }

    togglePlayback() {
      if (!this.video) return;

      if (this.video.paused) {
        this.video.play().then(() => this.renderPlaybackState(true)).catch(() => this.renderPlaybackState(false));
      } else {
        this.video.pause();
        this.renderPlaybackState(false);
      }
    }

    renderPlaybackState(isPlaying) {
      if (!this.toggle || !this.label) return;
      this.toggle.classList.toggle('is-paused', !isPlaying);
      this.toggle.setAttribute('aria-label', isPlaying ? 'Pause ambient video' : 'Play ambient video');
      this.label.textContent = isPlaying ? 'Pause' : 'Play';
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('ondelie-media-story')) {
    customElements.define('ondelie-media-story', OndelieMediaStory);
  }
})();
